import { HomeOutlined } from "@ant-design/icons";
import type { BreadcrumbProps } from "antd";
import { ReactNode } from "react";
import { Link } from "react-router-dom";
import { ROUTES } from "~/utils";

export type BreadcrumbItemType = NonNullable<BreadcrumbProps["items"]>[number];

function isInternalPath(path: string): boolean {
  return path.startsWith("/") && !path.startsWith("//");
}

/** Home crumb — client-side navigation via React Router. */
export const breadcrumbHomeItem: BreadcrumbItemType = {
  title: (
    <Link to={ROUTES.home}>
      <HomeOutlined />
    </Link>
  ),
};

/** Static (non-link) breadcrumb segment. */
export const breadcrumbItem = (title: ReactNode): BreadcrumbItemType => ({
  title,
});

/** Breadcrumb segment that navigates in-app without a full page reload. */
export const breadcrumbLinkItem = (
  to: string,
  title: ReactNode
): BreadcrumbItemType =>
  isInternalPath(to)
    ? { title: <Link to={to}>{title}</Link> }
    : { title, href: to };
